// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.pricingcarddatatosales-container {
  display: grid;
  gap: 20px;
  padding: 20px;
}

.pricingcarddatatosales {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: grid;
  gap: 15px;
}

.pricingcarddatatosales .pricing-card-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.pricingcarddatatosales .pricing-card-item {
  font-size: 0.875rem;
  color: #555;
  line-height: 1.5;
}

.pricingcarddatatosales .pricing-card-item strong {
  font-weight: bold;
  color: #000;
}

/* Grid setup for different screen sizes */
@media (min-width: 600px) {
  /* Tablet layout: 2 columns */
  .pricingcarddatatosales .pricing-card-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 1024px) {
  /* Desktop layout: 3 columns */
  .pricingcarddatatosales .pricing-card-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

/* Button styling for the 'View Details' button */
.pricingcarddatatosales .view-detail-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 0.875rem;
  align-self: center;
  transition: background-color 0.3s;
  /* width: 100%; */
  margin-top: 15px;
}

.pricingcarddatatosales .view-detail-btn:hover {
  background-color: #0056b3;
}
.pricingcarddatatosales_button {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* *********** */

.receive-actual-price-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.receive-actual-price-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.receive-actual-price-popup-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.receive-actual-price-grid {
  /* display: grid;
  grid-template-columns: 1fr;
  gap: 15px; */
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.receive-actual-price-price-item {
  font-size: 1rem;
  color: #333;
  line-height: 1.5;
}

.receive-actual-price-price-item strong {
  font-weight: bold;
  color: #000;
}

/* Responsive grid adjustments for various screen sizes */
@media (min-width: 600px) {
  .receive-actual-price-grid {
    grid-template-columns: 1fr 1fr; /* Tablet: 2 columns */
  }
}

@media (min-width: 1024px) {
  .receive-actual-price-grid {
    grid-template-columns: 1fr 1fr 1fr; /* Desktop: 3 columns */
  }
}

/* Button styling for the close button */
.receive-actual-price-close-popup-btn {
  background-color: #ff4747;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  width: 100%;
  margin-top: 20px;
}

.receive-actual-price-close-popup-btn:hover {
  background-color: #ff2a2a;
}
/* ****** */

.showNewPriceFormpopup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.showNewPriceFormpopup-popup {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  height: 600px;
  overflow: auto;
}

.showNewPriceFormpopup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.showNewPriceFormpopup-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  text-align: center;
}

.showNewPriceFormpopup-form {
  display: grid;
  gap: 1rem;
}

.showNewPriceFormpopup-input {
  padding: 0.6rem;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 1rem;
}

.showNewPriceFormpopup-submit {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 0.8rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: bold;
  transition: background 0.2s;
}

.showNewPriceFormpopup-submit:hover {
  background-color: #0056b3;
}

/* Responsive */
@media (max-width: 600px) {
  .showNewPriceFormpopup-popup {
    width: 95%;
    padding: 1.5rem;
  }
}

.viewPriceAddedBySales-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
}

.viewPriceAddedBySales-card {
  background: #fff;
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  position: relative;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.viewPriceAddedBySales-close {
  position: absolute;
  top: 10px;
  right: 15px;
  font-size: 20px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.viewPriceAddedBySales-title {
  margin-bottom: 1.5rem;
  font-size: 24px;
  text-align: center;
  color: #333;
}

.viewPriceAddedBySales-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
}

.viewPriceAddedBySales-grid p {
  margin: 0;
  font-size: 16px;
  color: #444;
}

.viewPriceAddedBySales-grid strong {
  color: #000;
}

.viewPriceAddedBySales-updateButton {
  margin-top: 2rem;
  padding: 12px 20px;
  background-color: #2e7d32;
  color: #fff;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.viewPriceAddedBySales-updateButton:hover {
  background-color: #1b5e20;
}

/* Responsive Grid */
@media (min-width: 600px) {
  .viewPriceAddedBySales-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 900px) {
  .viewPriceAddedBySales-grid {
    grid-template-columns: 1fr 1fr 1fr;
  }
}

.finalSlip_DownLoad_button {
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #0056b3;
  color: white;
  margin-left: 2px;
}
.finalslipClose_button {
  padding: 10px 20px;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: red;
  color: white;
  margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/PricingCardDataToSales.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,0CAA0C;AAC1C;EACE,6BAA6B;EAC7B;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,8BAA8B;EAC9B;IACE,kCAAkC;EACpC;AACF;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,gBAAgB;;AAEhB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE;;cAEY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE;IACE,8BAA8B,EAAE,sBAAsB;EACxD;AACF;;AAEA;EACE;IACE,kCAAkC,EAAE,uBAAuB;EAC7D;AACF;;AAEA,wCAAwC;AACxC;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;AACA,WAAW;;AAEX;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.pricingcarddatatosales-container {\n  display: grid;\n  gap: 20px;\n  padding: 20px;\n}\n\n.pricingcarddatatosales {\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  display: grid;\n  gap: 15px;\n}\n\n.pricingcarddatatosales .pricing-card-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.pricingcarddatatosales .pricing-card-item {\n  font-size: 0.875rem;\n  color: #555;\n  line-height: 1.5;\n}\n\n.pricingcarddatatosales .pricing-card-item strong {\n  font-weight: bold;\n  color: #000;\n}\n\n/* Grid setup for different screen sizes */\n@media (min-width: 600px) {\n  /* Tablet layout: 2 columns */\n  .pricingcarddatatosales .pricing-card-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (min-width: 1024px) {\n  /* Desktop layout: 3 columns */\n  .pricingcarddatatosales .pricing-card-grid {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n/* Button styling for the 'View Details' button */\n.pricingcarddatatosales .view-detail-btn {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 15px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  align-self: center;\n  transition: background-color 0.3s;\n  /* width: 100%; */\n  margin-top: 15px;\n}\n\n.pricingcarddatatosales .view-detail-btn:hover {\n  background-color: #0056b3;\n}\n.pricingcarddatatosales_button {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n/* *********** */\n\n.receive-actual-price-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.receive-actual-price-popup {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.receive-actual-price-popup-content {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.receive-actual-price-grid {\n  /* display: grid;\n  grid-template-columns: 1fr;\n  gap: 15px; */\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.receive-actual-price-price-item {\n  font-size: 1rem;\n  color: #333;\n  line-height: 1.5;\n}\n\n.receive-actual-price-price-item strong {\n  font-weight: bold;\n  color: #000;\n}\n\n/* Responsive grid adjustments for various screen sizes */\n@media (min-width: 600px) {\n  .receive-actual-price-grid {\n    grid-template-columns: 1fr 1fr; /* Tablet: 2 columns */\n  }\n}\n\n@media (min-width: 1024px) {\n  .receive-actual-price-grid {\n    grid-template-columns: 1fr 1fr 1fr; /* Desktop: 3 columns */\n  }\n}\n\n/* Button styling for the close button */\n.receive-actual-price-close-popup-btn {\n  background-color: #ff4747;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.receive-actual-price-close-popup-btn:hover {\n  background-color: #ff2a2a;\n}\n/* ****** */\n\n.showNewPriceFormpopup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2;\n}\n\n.showNewPriceFormpopup-popup {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 90%;\n  max-width: 600px;\n  position: relative;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  height: 600px;\n  overflow: auto;\n}\n\n.showNewPriceFormpopup-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: transparent;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.showNewPriceFormpopup-title {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n.showNewPriceFormpopup-form {\n  display: grid;\n  gap: 1rem;\n}\n\n.showNewPriceFormpopup-input {\n  padding: 0.6rem;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 1rem;\n}\n\n.showNewPriceFormpopup-submit {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  padding: 0.8rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-weight: bold;\n  transition: background 0.2s;\n}\n\n.showNewPriceFormpopup-submit:hover {\n  background-color: #0056b3;\n}\n\n/* Responsive */\n@media (max-width: 600px) {\n  .showNewPriceFormpopup-popup {\n    width: 95%;\n    padding: 1.5rem;\n  }\n}\n\n.viewPriceAddedBySales-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 1rem;\n}\n\n.viewPriceAddedBySales-card {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 12px;\n  max-width: 600px;\n  width: 100%;\n  position: relative;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n}\n\n.viewPriceAddedBySales-close {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  font-size: 20px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.viewPriceAddedBySales-title {\n  margin-bottom: 1.5rem;\n  font-size: 24px;\n  text-align: center;\n  color: #333;\n}\n\n.viewPriceAddedBySales-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n}\n\n.viewPriceAddedBySales-grid p {\n  margin: 0;\n  font-size: 16px;\n  color: #444;\n}\n\n.viewPriceAddedBySales-grid strong {\n  color: #000;\n}\n\n.viewPriceAddedBySales-updateButton {\n  margin-top: 2rem;\n  padding: 12px 20px;\n  background-color: #2e7d32;\n  color: #fff;\n  font-weight: bold;\n  border: none;\n  border-radius: 8px;\n  width: 100%;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.viewPriceAddedBySales-updateButton:hover {\n  background-color: #1b5e20;\n}\n\n/* Responsive Grid */\n@media (min-width: 600px) {\n  .viewPriceAddedBySales-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (min-width: 900px) {\n  .viewPriceAddedBySales-grid {\n    grid-template-columns: 1fr 1fr 1fr;\n  }\n}\n\n.finalSlip_DownLoad_button {\n  padding: 10px 20px;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: #0056b3;\n  color: white;\n  margin-left: 2px;\n}\n.finalslipClose_button {\n  padding: 10px 20px;\n  font-size: 1rem;\n  font-weight: 600;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background-color: red;\n  color: white;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
